import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  useScrollTrigger,
} from '@mui/material'
import { ArrowBack, Delete, Edit } from '@mui/icons-material'
import { Workout } from '../providers/workouts'
import { useLocation, useNavigate } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import { useState } from 'react'
import { useUserHasWorkoutEditPermission } from '../hooks/permissions'
import { DEFAULT_WORKOUT_TYPES, useWorkoutSettings } from '../providers/workout-settings'

type Props = {
  window?: () => Window
  workout?: Workout
  path?: string
  edit?: boolean
  onDelete?: () => void
}

export function SetWorkoutHeader(type: string) {
  return (
    DEFAULT_WORKOUT_TYPES.find((workoutType) => workoutType.id === type)?.name ??
    type ??
    'Cirkelträning'
  )
}

export default function AppHeader({
  window,
  workout,
  path,
  edit,
  onDelete,
}: Props) {
  const editPermission = useUserHasWorkoutEditPermission(workout)
  const { getWorkoutTypeName } = useWorkoutSettings()
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: workout ? 100 : 0,
    target: window ? window() : undefined,
  })
  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo
  const handleBack = () => {
    if (returnTo) {
      navigate(returnTo)
      return
    }

    navigate(-1)
  }

  return (
    <AppBar elevation={trigger ? 1 : 0} color={'inherit'}>
      <Toolbar sx={{ margin: '0 auto' }}>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={handleBack}>
          <ArrowBack sx={{ fontSize: '1.8rem' }} />
        </IconButton>
        <Typography
          variant="h6"
          component="div"
          color="inherit"
          sx={{ flexGrow: 1, maxWidth: '20rem', minWidth: '17rem' }}>
          {workout
            ? edit
              ? 'Redigera Pass'
              : trigger && getWorkoutTypeName(workout.type)
            : 'Skapa Pass'}
        </Typography>
        {editPermission && path !== undefined ? (
          <IconButton
            aria-label="edit"
            size="large"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
            component={RouterLink}
            to={path}>
            <Edit />
          </IconButton>
        ) : (
          editPermission &&
          workout &&
          edit &&
          workout.participantsCount <= 0 &&
          onDelete && (
            <IconButton
              aria-label="delete"
              size="large"
              color="inherit"
              onClick={handleOpen}>
              <Delete color="error" />
            </IconButton>
          )
        )}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Vill du ta bort passet? Detta går inte att ångra
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>
              Ångra
            </Button>
            <Button onClick={onDelete}>Ta bort</Button>
          </DialogActions>
        </Dialog>
      </Toolbar>
    </AppBar>
  )
}
